import { createServerFn } from "@tanstack/react-start";
import z from "zod";
import { mapsCallSourceSchema } from "~/lib/maps/attribution";
import { geocodeLocationInternal } from "./geocode-location";

export const geocodeAddress = createServerFn({ method: "POST" })
  .inputValidator(
    z.object({
      query: z.string().trim().min(1).max(240),
      /** Callsite for cost attribution — a finite enum, never free text. */
      source: mapsCallSourceSchema,
    })
  )
  .handler(async (ctx) => {
    const result = await geocodeLocationInternal(ctx.data.query, {
      source: ctx.data.source,
      suppressInputLogging: true,
    });
    if (!result) return undefined;

    return {
      lat: result.lat,
      lng: result.lng,
      formattedAddress: result.formattedAddress ?? null,
      viewport: result.viewport,
      bounds: result.bounds,
    };
  });
